import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&',
        subject: '=',
        itemIds: '=',
        userAssignments: '=',
        removeMissingRoles: '=',
        context: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.onClose()"></button>
            <h2>{{ 'manage.Roles' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="alert alert-warn" ng-if="vm.warning">{{ vm.warning }}</div>
            <div class="alert alert-danger" ng-if="vm.error">{{ vm.error }}</div>
            <div class="alert alert-notify" ng-if="vm.PrivilegeService.isSuperAdmin()">
                {{ 'manage.Attention! System roles, that are not displayed to regular users, are displayed in the list' | translate }}
            </div>
            <div class="form">
                <ul class="checkboxes02">
                    <li ng-repeat="item in vm.list.items" ng-if="item.name">
                        <label>
                            <input type="checkbox" ng-checked="vm.hasRole(item.id)" ng-click="vm.toggleRole(item.id)">
                            <span>{{ item.name }}</span>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li  class="primary" ng-if="!vm.warning"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, lodash,
                 RoleResource, UserResource, SiteResource,
                 ListFactory,
                 PrivilegeService) {
        this.lodash = lodash;
        this.$translate = $translate;
        this.UserResource = UserResource;
        this.SiteResource = SiteResource;
        this.RoleResource = RoleResource;
        this.ListFactory = ListFactory;
        this.PrivilegeService = PrivilegeService;
    }

    $onInit () {
        this.error = '';
        this.warning = this.itemIds.length ? '' : this.warning = this.$translate.instant('manage.Check items from list first');

        this.list = this.ListFactory.createWithoutPagination(this.RoleResource.query.bind(this.RoleResource));
        if (this.PrivilegeService.isSuperAdmin()) {
            this.list.fetch({ includeNonVisible: true });
        }
        else {
            this.list.fetch();
        }

        this.roleIds = [];
        // if userAssignments are present it is single row context of editing
        if (this.userAssignments.length) {
            this.lodash.forEach(this.itemIds, (itemId) => {
                if (this.userAssignments[itemId] !== undefined) {
                    this.roleIds = this.userAssignments[itemId].map((val) => (val.roleId));
                }
            });
        }
    }

    hasRole (key) {
        return this.lodash.includes(this.roleIds, key);
    }

    toggleRole (key) {
        if (this.hasRole(key)) {
            this.lodash.pull(this.roleIds, key);
        }
        else {
            this.roleIds.push(key);
        }
    }

    save () {
        const apiInput = this.itemIds.map((val) => {
            if (this.context === 'user') {
                this.row = {
                    siteId: val,
                    roles: this.roleIds,
                    removeMissingRoles: this.removeMissingRoles
                };
            }
            else {
                this.row = {
                    userId: val,
                    roles: this.roleIds,
                    removeMissingRoles: this.removeMissingRoles
                };
            }
            return this.row;
        });

        if (apiInput.length) {
            this.error = '';
            if (this.context === 'user') {
                this.UserResource
                    .setSiteRoles({ id: this.subject.id }, apiInput)
                    .$promise
                    .then((result) => this.onUpdate(result))
                        .catch((error) => {
                            this.error = this.lodash.get(error.data, '[0].message');
                        });
            }
            else {
                this.SiteResource
                    .setUserRoles({ id: this.subject.id }, apiInput)
                    .$promise
                    .then((result) => this.onUpdate(result))
                        .catch((error) => {
                            this.error = this.lodash.get(error.data, '[0].message');
                        });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/manage/role/index.js